const sanitizePhone = (value) => {
    return value
      .replace(/\D/g, '') // remove all non-digits
      .replace(/^(\+91|91|0)/, '') // remove +91 or 91 or 0
      .slice(0, 10); // limit to 10 digits
  };


  export default sanitizePhone;